import React, { createContext, useState, useEffect, useContext } from "react";

const SidebarContext = createContext({
  isMobile: false,
  isCollapsed: false,
  toggleSidebar: () => {},
});

export const SidebarProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 1024);

  useEffect(() => {
    let prevMobile = window.innerWidth < 1024;
    const handleResize = () => {
      const nowMobile = window.innerWidth < 1024;
      setIsMobile(nowMobile);
      if (prevMobile && !nowMobile) setIsCollapsed(false);
      if (!prevMobile && nowMobile) setIsCollapsed(true);
      prevMobile = nowMobile;
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsCollapsed((c) => !c);

  return (
    <SidebarContext.Provider value={{ isMobile, isCollapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);

export default SidebarContext;
